import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Modal } from 'antd'
import { useAuthStore } from '@/stores/authStore'

/**
 * Ignorar vale só para esta sessão, de propósito: não há marca em localStorage como no vídeo de
 * boas-vindas, então o aviso volta no próximo login e só some quando a senha muda de verdade.
 */
export function AvisoDeSenhaPadrao() {
  const usandoSenhaPadrao = useAuthStore((s) => s.usandoSenhaPadrao)
  const [ignorado, setIgnorado] = useState(false)
  const navigate = useNavigate()

  if (!usandoSenhaPadrao || ignorado) return null

  // Ir para a tela também fecha: `usandoSenhaPadrao` só cai quando a senha muda de verdade, então
  // sem isto o aviso ficaria por cima do próprio formulário que ele mandou preencher.
  function irParaATroca() {
    setIgnorado(true)
    navigate('/alterar-senha')
  }

  return (
    <Modal
      open
      centered
      title="Você está usando a senha padrão"
      okText="Alterar senha"
      cancelText="Agora não"
      onOk={irParaATroca}
      onCancel={() => setIgnorado(true)}
    >
      <p>
        Sua senha são os 6 primeiros dígitos do seu CPF, definida no cadastro. Quem cadastrou o seu
        acesso sabe qual é.
      </p>
      <p className="!mb-0">Vale trocar por uma que só você conheça.</p>
    </Modal>
  )
}
